import { render, staticRenderFns } from "./count-down-button.vue?vue&type=template&id=47ff6a54&"
import script from "./count-down-button.vue?vue&type=script&lang=js&"
export * from "./count-down-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports